module.exports = __webpack_public_path__ + "static/media/Mobiletwitterlogo.9e35d5bc.PNG";